import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IAppState } from "../../state/app.state";
import { IClientState } from "../../state/client.state";

export const getClientState = createFeatureSelector<IAppState, IClientState>('client');

export const getSearchOptionsData = createSelector(
    getClientState,
    (state: IClientState) => {
        return {
            doesDefaultClientListExist: state.doesDefaultClientListExist,
            clientGroups: state.clientGroups
        };
    }
);

export const selectSelectedClientGroup = createSelector(
    getClientState,
    (state: IClientState) => state.selectedClientGroup
);

export const selectMembersOfSelectedClientGroup = createSelector(
    getClientState,
    (state: IClientState) => state.selectedClientGroup.Members
);